import { render, staticRenderFns } from "./paginationFirstIcon.vue?vue&type=template&id=f9d7a4fe&"
import script from "./paginationFirstIcon.vue?vue&type=script&lang=js&"
export * from "./paginationFirstIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports